import React from 'react';
import { useSelector } from 'react-redux';
import { Grid, Row, Col, Text } from 'rsuite';
import {
  selectSelectedPaymentMethod,
  selectPaymentSuccessInfo,
} from '../../../../store/slices/payment/paymentSelectors';
import { PAYMENT_METHODS } from '../../constants';
import {
  selectConfigSettings,
  selectConfigExpressSettingsName,
} from '../../../../store/slices/config/configSelectors';
import PaymentCompletedCheck from './PaymentCompletedCheck';

const ApplySuccessFields = () => {
  const paymentSuccessInfo = useSelector(selectPaymentSuccessInfo);
  const selectedPaymentMethod = useSelector(selectSelectedPaymentMethod);
  const settings = useSelector(selectConfigSettings);
  const placeDisplayName = useSelector(selectConfigExpressSettingsName);
  const { express, rentalType } = settings;

  const renderApplicationStatusMessage = () => {
    if (express?.registration?.application?.lic_auto_approved === true) {
      return ` We have emailed you details of the application.`;
    }
    return ` Your application will be reviewed and processed by ${placeDisplayName} ${rentalType?.toUpperCase()}. We will contact you via email on the status of your application.`;
  };

  return (
    <Grid className="content-section">
      <Row>
        <Col xs={24}>
          <>
            <Grid
              fluid
              className="mb-24"
            >
              <Row>
                <Col xs={24}>
                  <Text className="mv-8">
                    Thank you! Your {express?.registration?.verbiage}{' '}
                    Application has been submitted successfully!{' '}
                    {paymentSuccessInfo?.paymentConfirmation
                      ? `Your confirmation number is: ${paymentSuccessInfo?.paymentConfirmation}.`
                      : ''}
                    {renderApplicationStatusMessage()}
                  </Text>
                </Col>
              </Row>
            </Grid>
            {selectedPaymentMethod === PAYMENT_METHODS.CHECK && (
              <PaymentCompletedCheck />
            )}
          </>
        </Col>
      </Row>
    </Grid>
  );
};

export default ApplySuccessFields;
